import { useQuery } from '@tanstack/react-query';
import { get } from '../../api/client';
import { dataToOptionsTransformer } from '../../Services/transformer/dataToOptionsTransformer';

export const SCHOOL_BLOCK_KEY = {
  BLOCK_LIST: 'BLOCK_LIST',
};

export const useGetSchoolBlocksOptions = () =>
  useQuery([SCHOOL_BLOCK_KEY.BLOCK_LIST], () => {
    const blockOptions = get({ url: 'api/v1/school-block' }).then((blocks) => {
      return dataToOptionsTransformer({
        dataToTransform: blocks,
        value: 'id',
        text: 'name',
      });
    });
    return blockOptions;
  });
